import _ from 'lodash';
import getTripModes from '../getTripModes';
import formatBookButtonTextByModes from './formatBookButtonTextByModes';

const formatBookButtonTextByTrip = (trip, travelAgency, policyStatus) => {
  if (!_.isEmpty(policyStatus && policyStatus.buttonState && policyStatus.buttonState.label))
    return policyStatus.buttonState.label;
  const { itinerariesOnHold, itinerariesToBook } = getTripModes(trip, travelAgency);
  if (itinerariesOnHold.length === 0) return 'Book';

  return formatBookButtonTextByModes(itinerariesOnHold, itinerariesToBook);
};

export default formatBookButtonTextByTrip;
